




















import { Prop, Component, Vue } from 'vue-property-decorator'

@Component
export default class IconArrow extends Vue {
    @Prop({ type: Number, default: 15 }) readonly size!: number
    @Prop({type: String, default: 'up'}) readonly direction!: string

}
